export function evaluateGuards(tour, traits, rng = Math.random) {
    const guards = tour.guards ?? [];
    return guards.every((g) => {
        switch (g.name) {
            case 'roleIn':
                return !!traits.role && Array.isArray(g.values) && g.values.includes(traits.role);
            case 'planIn':
                return !!traits.plan && Array.isArray(g.values) && g.values.includes(traits.plan);
            case 'flagTrue':
                return !!traits.flags?.[g.key];
            case 'firstRunSinceVersion':
                return (!traits.firstSeenVersion || traits.firstSeenVersion < g.version);
            case 'percentRollout':
                return rng() * 100 < Number(g.percent ?? 0);
            default:
                return true;
        }
    });
}
/** Deterministic RNG per (tenant|tour|user) to make rollout sticky. */
export function stickyRng(seed) {
    let h = 2166136261 ^ seed.length;
    for (let i = 0; i < seed.length; i++)
        h = Math.imul(h ^ seed.charCodeAt(i), 16777619);
    return () => {
        h ^= h << 13;
        h ^= h >>> 17;
        h ^= h << 5;
        return ((h >>> 0) % 1_000_000) / 1_000_000;
    };
}
//# sourceMappingURL=eval.js.map